import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Chevron, { SIZES } from 'components/Chevron';
import IconButton from 'components/IconButton';
import Theme from 'styles/theme';

import { DIRECTIONS, COLORWAY_PICKER_APPEARANCES, NAV_SIZES } from './constants';

const ColorwayPickerNavigationArrow = ({ direction, appearance, navSize, ...otherProps }) => {
  return (
    <IconButton
      className={ClassNames(
        'ColorwayPickerNavigationArrow',
        {
          'ColorwayPickerNavigationArrow--round':
            appearance === COLORWAY_PICKER_APPEARANCES.COLOR_SWATCHES,
          'ColorwayPickerNavigationArrow--square':
            appearance === COLORWAY_PICKER_APPEARANCES.THUMBNAILS,
        },
        {
          'ColorwayPickerNavigationArrow--small': navSize === NAV_SIZES.SMALL,
          'ColorwayPickerNavigationArrow--medium': navSize === NAV_SIZES.MEDIUM,
        }
      )}
      {...otherProps}
    >
      <div className="ColorwayPickerNavigationArrow__content">
        <Chevron
          fillColor="colors-black-80"
          direction={direction}
          size={appearance === COLORWAY_PICKER_APPEARANCES.THUMBNAILS ? SIZES.LARGE : SIZES.MEDIUM}
        />
      </div>
      <style jsx>{`
        .ColorwayPickerNavigationArrow--round {
          border-color: ${Theme.get('colors-black-80')};
        }

        .ColorwayPickerNavigationArrow__content {
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid ${Theme.get('colors-black-20')};
          height: 100%;
          width: 100%;
        }
      `}</style>
      <style jsx global>{`
        .ColorwayPickerNavigationArrow__content {
          margin: 0 auto;
        }

        // Duplicate classname for extra specificity
        .IconButton.ColorwayPickerNavigationArrow.ColorwayPickerNavigationArrow--round {
          height: 100%;
          width: 100%;
        }

        .IconButton.ColorwayPickerNavigationArrow.ColorwayPickerNavigationArrow {
          display: block;
          margin: 0 auto;
        }

        .IconButton.ColorwayPickerNavigationArrow.ColorwayPickerNavigationArrow--round.ColorwayPickerNavigationArrow--small
          .ColorwayPickerNavigationArrow__content {
          height: ${Theme.get('spacing') * 4}px;
          width: ${Theme.get('spacing') * 4}px;
        }

        .IconButton.ColorwayPickerNavigationArrow.ColorwayPickerNavigationArrow--round.ColorwayPickerNavigationArrow--medium
          .ColorwayPickerNavigationArrow__content {
          height: ${Theme.get('spacing') * 5}px;
          width: ${Theme.get('spacing') * 5}px;
        }

        .IconButton.ColorwayPickerNavigationArrow.ColorwayPickerNavigationArrow--square {
          height: 100%;
          width: 100%;
        }

        .ColorwayPickerNavigationArrow--round .ColorwayPickerNavigationArrow__content {
          border-radius: 50%;
        }

        .ColorwayPickerNavigationArrow:not(:disabled)
          .ColorwayPickerNavigationArrow__content:hover {
          border-color: ${Theme.get('colors-black-60')};
          transition: border-color ease-in-out ${Theme.get('transition-duration') / 2}ms;
        }
      `}</style>
    </IconButton>
  );
};

ColorwayPickerNavigationArrow.propTypes = {
  direction: PropTypes.oneOf(Object.values(DIRECTIONS)),
  appearance: PropTypes.oneOf(Object.values(COLORWAY_PICKER_APPEARANCES)),
  navSize: PropTypes.oneOf(Object.values(NAV_SIZES)),
};

ColorwayPickerNavigationArrow.defaultProps = {
  direction: DIRECTIONS.LEFT,
  appearance: COLORWAY_PICKER_APPEARANCES.COLOR_SWATCHES,
  navSize: NAV_SIZES.MEDIUM,
};

export default ColorwayPickerNavigationArrow;
